module.exports = __webpack_public_path__ + "img/OZO_landing_logo.0014710b.svg";